import Vue from 'vue'
import * as jsonpatch from 'fast-json-patch/index.mjs'

const luFundingSource = {
  state: {
    luFundingSources: [],
    selectedLuFundingSource: {},
    selectedLuFundingSourceOriginal: {},
    saving: false,
    searchCount: 0,
  },

  getters: {
    luFundingSources(state) {
      return state.luFundingSources
    },
    selectedLuFundingSource(state) {
      return state.selectedLuFundingSource
    },
    selectedLuFundingSourceOriginal(state) {
      return state.selectedLuFundingSourceOriginal
    },
    loading(state) {
      return state.searchCount > 0
    },
  },

  mutations: {
    luFundingSources(state, payload) {
      state.luFundingSources = payload
    },
    selectedLuFundingSource(state, payload) {
      state.selectedLuFundingSource = JSON.parse(JSON.stringify(payload))
    },
    selectedLuFundingSourceOriginal(state, payload) {
      state.selectedLuFundingSourceOriginal = JSON.parse(
        JSON.stringify(payload)
      )
    },
    saving(state, payload) {
      state.saving = payload
    },
    searchCount(state, payload) {
      state.searchCount = payload
    },
    increaseSearchCount(state, payload) {
      state.searchCount = state.searchCount + 1
    },
    decreaseSearchCount(state, payload) {
      state.searchCount = state.searchCount - 1
    },
  },

  actions: {
    setSelectedLuFundingSource(context, payload) {
      context.commit('selectedLuFundingSource', payload)
    },
    async loadLuFundingSources(context, payload) {
      const url = 'LuFundingSource'
      try {
        let res = await Vue.prototype.$axios.get(url)
        context.commit('luFundingSources', res.data)
        return res
      } catch (err) {
        console.error(err)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async refreshSelectedLuFundingSource(context, payload) {
      if (
        context.state.selectedLuFundingSource &&
        context.state.selectedLuFundingSource.Id > 0
      ) {
        return await context.dispatch(
          'loadSelectedLuFundingSource',
          context.state.selectedLuFundingSource.Id
        )
      }
    },
    async loadSelectedLuFundingSource(context, payload) {
      if (
        context.state.selectedLuFundingSource &&
        context.state.selectedLuFundingSource.Id != payload
      ) {
        context.commit('selectedLuFundingSource', {})
      }
      const url = 'LuFundingSource/' + payload
      context.commit('increaseSearchCount')
      try {
        let res = await Vue.prototype.$axios.get(url)
        context.commit('selectedLuFundingSource', res.data)
        context.commit('selectedLuFundingSourceOriginal', res.data)
        context.commit('decreaseSearchCount')
        return res
      } catch (err) {
        console.error(err)
        context.commit('decreaseSearchCount')
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async clearLookupCacheAndReloadLuFundingSources(context, payload) {
      await caches.delete('apilookup-cache')
      return await context.dispatch('loadLuFundingSources')
    },
    async createLuFundingSource(context, payload) {
      const url = `LuFundingSource`
      context.commit('saving', true)
      try {
        let res = await Vue.prototype.$axios.post(url, payload)
        context.dispatch(
          'messages/toastMessage',
          { color: 'success', message: 'funding source created' },
          { root: true }
        )
        //if you will always need to reload the list after an item is created
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadLuFundingSources')
        context.commit('saving', false)
        return res
      } catch (err) {
        console.error(err)
        context.commit('saving', false)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async patchLuFundingSource(context, payload) {
      var item = context.state.selectedLuFundingSource
      if (
        payload.Id &&
        payload.Id == context.state.selectedLuFundingSourceOriginal.Id
      ) {
        item = payload
      }
      var patchPayload = {}
      if (!payload.patchDoc || !payload.Id) {
        let original = context.state.selectedLuFundingSourceOriginal
        let current = item
        patchPayload.Id = item.Id
        var diff = jsonpatch.compare(original, current)
        patchPayload.patchDoc = diff
      } else {
        patchPayload = payload
      }
      if (patchPayload.patchDoc.length > 0) {
        const url = `LuFundingSource/${patchPayload.Id}`
        context.commit('saving', true)
        try {
          let res = await Vue.prototype.$axios.patch(url, patchPayload.patchDoc)
          context.dispatch(
            'messages/toastMessage',
            { color: 'success', message: 'funding source updated' },
            { root: true }
          )
          //if you will always need to reload the list after an update
          //you can uncomment out the following dispatch line.
          //Alternatively you can reload whatever object you need
          //when the promise resolves in the component that called it.
          //context.dispatch('loadLuFundingSources')
          context.commit('saving', false)
          return res
        } catch (err) {
          console.error(err)
          context.commit('saving', false)
          context.dispatch('errors/handleError', err, { root: true })
          throw err
        }
      } else {
        return 'no changes'
      }
    },
    async updateLuFundingSource(context, payload) {
      const url = `LuFundingSource/${payload.Id}`
      context.commit('saving', true)
      try {
        let res = await Vue.prototype.$axios.put(url, payload)
        context.dispatch(
          'messages/toastMessage',
          { color: 'success', message: 'funding source updated' },
          { root: true }
        )
        //if you will always need to reload the list after an update
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadLuFundingSources')
        context.commit('saving', false)
        return res
      } catch (err) {
        console.error(err)
        context.commit('saving', false)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async saveLuFundingSource(context, payload) {
      if (payload.Id > 0) {
        return context.dispatch('updateLuFundingSource', payload)
      } else {
        return context.dispatch('createLuFundingSource', payload)
      }
    },
    async deleteLuFundingSource(context, payload) {
      const url = `LuFundingSource/${payload.Id}`
      try {
        let res = await Vue.prototype.$axios.delete(url)
        context.dispatch(
          'messages/toastMessage',
          { color: 'success', message: 'funding source deleted' },
          { root: true }
        )
        //if you will always need to reload the list after a delete
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadLuFundingSources')
        return res
      } catch (err) {
        console.error(err)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
  },
}

export default luFundingSource
